<!--
 * @Author: Hyman Choi
 * @Date: 2021-01-04 14:24:02
 * @LastEditTime: 2021-01-07 16:34:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.LiveWeb\src\views\notificationManagement.vue
-->
<template>
	<div class="app-container">
		<div>
			<el-button type="primary" size="small" @click="goback">返回</el-button>
		</div>
		
		<el-row :gutter="40" style="margin-top: 20px">
			<!-- 短信内容 -->
			<el-col :span="8">
				<el-form ref="form" :model="form" label-width="150px">
					<el-form-item label="短信模板">
						<el-input type="textarea" v-model="form.template" rows="3" disabled>
						</el-input>
					</el-form-item>
					<el-form-item label="自定义内容">
						<el-input type="textarea" v-model="form.content" rows="3" maxlength="40" show-word-limit
							placeholder="即为上方模板{内容}" />
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="send()">
							发送
						</el-button>
						<el-button type="danger" size="small" @click="clearContent()">
							清空
						</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 可选用户 -->
			<el-col :span="8">
				<el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
					<!-- 预约用户 -->
					<el-tab-pane label="预约用户" name="reserveUsersList">
						<div class="topbar">
							<div>
								<el-input v-model="searchReserveUser" size="small" style="width: 400px"
									@keyup.enter.native="getLiveAppointUser()" />
							</div>
							<el-button type="primary" size="small" :disabled="isAllSelected" @click="addAllUsers()">
								全选
							</el-button>
						</div>
						<div class="list">
							<div class="item" v-for="(item, index) of reserveUsersList" :key="index + '1'">
								<span class="name">{{ item.nickname }}</span>
								<span class="phone">{{ item.mobilePhone }}</span>
								<el-button :type="item.selected ? 'danger' : 'success'" size="small"
									@click="item.selected ? removeUser(index) : addUser(index)">
									{{ item.selected ? '移除' : '添加' }}
								</el-button>
							</div>
						</div>
						<div class="bottom" v-show="totalCount > pageSize">
							<el-pagination background layout="prev, pager, next" :total="totalCount"
								:page-size="pageSize" :current-page="currentPage" @current-change="currentChange">
							</el-pagination>
						</div>
					</el-tab-pane>

					<!-- 关注用户 -->
					<el-tab-pane v-if="showSubscribeUsersList" label="关注用户" name="subscribeUsersList">
						<div class="topbar">
							<div>
								<el-input v-model="searchSubscribeUser" size="small" style="width: 400px"
									@keyup.enter.native="getMyFollowingList()" />
							</div>
							<el-button type="primary" size="small" :disabled="isAllSelected" @click="addAllUsers()">
								所有用户
							</el-button>
						</div>
						<div class="list">
							<div class="item" v-for="(item, index) of subscribeUsersList" :key="index + '2'">
								<span class="name">{{ item.Nickname }}</span>
								<span class="phone">{{ item.MobilePhone }}</span>
								<el-button :type="item.selected ? 'danger' : 'success'" size="small"
									@click="item.selected ? removeUser(index) : addUser(index)">
									{{ item.selected ? '移除' : "添加" }}
								</el-button>
							</div>
						</div>
						<div class="bottom" v-show="totalCount > pageSize">
							<el-pagination background layout="prev, pager, next" :total="totalCount"
								:page-size="pageSize" :current-page="currentPage" @current-change="currentChange">
							</el-pagination>
						</div>
					</el-tab-pane>

					<!-- 所有用户 -->
					<el-tab-pane label="所有用户" name="allUsersList">
						<div class="topbar">
							<div>
								<el-input v-model="searchGuestUser" size="small" style="width: 400px"
									@keyup.enter.native="getUserList()" />
							</div>
							<el-button type="primary" size="small" @click="getUserList()">
								搜索
							</el-button>
						</div>
						<div class="list">
							<div class="item" v-for="(item, index) of allUsersList" :key="index + '3'">
								<span class="name">{{ item.Nickname }}</span>
								<span class="phone">{{ item.MobilePhone }}</span>
								<el-button :type="item.selected ? 'danger' : 'success'" size="small"
									@click="item.selected ? removeUser(index) : addUser(index)">
									{{ item.selected ? '移除' : '添加' }}
								</el-button>
							</div>
						</div>
						<div class="bottom" v-show="totalCount > pageSize">
							<el-pagination background layout="prev, pager, next" :total="totalCount"
								:page-size="pageSize" :current-page="currentPage" @current-change="currentChange">
							</el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</el-col>

			<!-- 已添加用户 -->
			<el-col :span="8">
				<el-card>
					<div slot="header">已添加用户</div>
					<div>
						<div class="topbar">
							<div></div>
							<el-button type="danger" size="small" @click="removeAllAddedUser()">
								清空
							</el-button>
						</div>
						<div class="list addedList">
							<div class="item" v-for="(item, index) of addedList" :key="index + '4'">
								<span class="name">{{ item.nickname }}</span>
								<span class="phone">{{ item.mobilePhone }}</span>
								<el-button type="danger" size="small" @click="removeAddedUser(index)">
									移除
								</el-button>
							</div>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {
		sendNotification,
		getLiveAppointUser,
		getMyFollowingList,
		getUserList
	} from '@/api/mai/liveManagement/notificationManagement'

	export default {
		data() {
			return {
				liveID: '', // 直播ID
				userID: '', // 用户ID
				form: {
					template: "尊敬的麦粒用户：主题为 { 内容 } 进行中，欢迎您进入麦粒医生app进行观看",
					content: ''
				},
				activeName: 'reserveUsersList', // 当前所选列表
				searchReserveUser: '', // 搜索预约用户
				reserveUsersList: [], // 预约用户列表
				showSubscribeUsersList: false,
				searchSubscribeUser: '', // 搜索关注用户
				subscribeUsersList: [], // 关注用户列表
				searchGuestUser: '', // 搜索所有用户
				allUsersList: [], // 所有用户列表
				addedList: [], // 已选用户列表
				totalCount: 0, // 总数
				pageSize: 10, // 单页数量
				currentPage: 1, // 当前页码
				isAllSelected: false // 是否已全选
			}
		},
		created() {
			this.liveID = this.$route.query.liveID
			this.userID = this.$route.query.userID
			this.showSubscribeUsersList = this.$i18n.locale === 'zh'
			this.getLiveAppointUser()
		},
		methods: {
			goback(){
				this.$router.go(-1)
			},
			/**
			 * 发送通知
			 */
			send() {
				// 判断自定义内容是否为空
				if (!this.form.content) {
					this.$message.error('发送内容不能为空.')
					return
				}

				// 提取所选用户手机号
				let phoneList = []
				this.addedList.forEach(i => phoneList.push(i.mobilePhone))

				// 判断所选用户是否为空
				if (!phoneList.length) {
					this.$message.error('请选择用户.')
					return
				}

				let data = {
					liveID: this.liveID,
					content: this.form.content,
					phoneList: phoneList
				}

				sendNotification(data).then(res => {
					if (res.message === 'SUCCESS') {
						this.$message({
							message: '发送成功.',
							type: 'success'
						})
					}
				})
			},
			/**
			 * 清空自定义内容
			 */
			clearContent() {
				this.form.content = ''
			},
			/**
			 * 切换可选观众列表
			 */
			handleClick(tab, event) {
				this.currentPage = 1
				this.totalCount = 0
				switch (tab.name) {
					case 'reserveUsersList':
						this.getLiveAppointUser()
						break
					case 'subscribeUsersList':
						this.getMyFollowingList()
						break
					case 'allUsersList':
						this.searchGuestUser = ''
						this.allUsersList = []
						break
				}
			},
			/**
			 * 检查当前列表是否已有被选
			 *
			 * @param list    当前列表
			 */
			checkSelected(list) {
				let arr = list
				this.addedList.forEach(j => {
					arr.forEach(i => {
						if (
							i.mobilePhone === j.mobilePhone ||
							i.MobilePhone === j.mobilePhone
						) {
							i.selected = true
						}
					})
				})
				return arr
			},
			/**
			 * 获取预约观众列表
			 */
			getLiveAppointUser() {
				let _this = this
				let params = {
					keyWord: this.searchReserveUser,
					liveID: _this.liveID,
					pageIndex: _this.currentPage,
					pageSize: _this.pageSize,
					sortName: '',
					sortOrder: '',
					where: ''
				}

				getLiveAppointUser(params).then(res => {
					_this.totalCount = res.data.total
					_this.reserveUsersList = this.checkSelected(res.data.list)
					_this.checkAllSelected()
				})
			},
			/**
			 * 获取主播关注用户列表
			 */
			getMyFollowingList() {
				let _this = this
				let params = {
					UserID: _this.userID,
					keyWord: _this.searchSubscribeUser
				}

				getMyFollowingList(params).then(res => {
					_this.totalCount = res.Total
					let start = (_this.currentPage - 1) * _this.pageSize
					let end = start + _this.pageSize
					console.log("getMyFollowingList " + start + " " + end)
					_this.subscribeUsersList = _this.checkSelected(res.Rows.slice(start, end))
					_this.checkAllSelected()
				})
			},
			/**
			 * 获取搜索用户列表
			 */
			getUserList() {
				let _this = this
				let params = {
					sortName: '',
					sortOrder: '',
					pageNumber: _this.currentPage,
					pageSize: _this.pageSize,
					keyWord: _this.searchGuestUser,
					where: ''
				}

				getUserList(params).then(res => {
					_this.totalCount = res.Total
					if (!_this.totalCount) {
						_this.$message({
							message: '没有搜索到对应用户',
							type: 'warning'
						})
					}
					_this.allUsersList = _this.checkSelected(res.Rows)
				})
			},
			/**
			 * 翻页
			 */
			currentChange(currentPage) {
				this.currentPage = currentPage
				switch (this.activeName) {
					case 'reserveUsersList':
						this.getLiveAppointUser()
						break
					case 'subscribeUsersList':
						this.getMyFollowingList()
						break
					case 'allUsersList':
						this.getUserList()
						break
				}
			},
			/**
			 * 选择当前页面所有用户
			 */
			addAllUsers() {
				switch (this.activeName) {
					case 'reserveUsersList':
						this.reserveUsersList.forEach(i => {
							if (!i.selected) {
								i.selected = true
								this.addedList.push({
									nickname: i.nickname,
									mobilePhone: i.mobilePhone,
									selected: false
								})
							}
						})
						break
					case 'subscribeUsersList':
						this.subscribeUsersList.forEach(i => {
							if (!i.selected) {
								i.selected = true
								this.addedList.push({
									nickname: i.Nickname,
									mobilePhone: i.MobilePhone,
									selected: false
								})
							}
						})
						break
				}
				this.isAllSelected = true
			},
			/**
			 * 检查当前列表是否已全选
			 */
			checkAllSelected() {
				let flag = 0
				switch (this.activeName) {
					case 'reserveUsersList':
						this.reserveUsersList.forEach(i => {
							if (!i.selected) {
								flag = 1
							}
						})
						break
					case 'subscribeUsersList':
						this.subscribeUsersList.forEach(i => {
							if (!i.selected) {
								flag = 1
							}
						})
						break
				}

				if (flag) {
					this.isAllSelected = false
				} else {
					this.isAllSelected = true
				}
			},
			/**
			 * 添加单个用户
			 *
			 * @param index    所选序号
			 */
			addUser(index) {
				let item = {
					nickname: '',
					mobilePhone: '',
					selected: false
				}

				switch (this.activeName) {
					case 'reserveUsersList':
						this.reserveUsersList[index].selected = true
						item.nickname = this.reserveUsersList[index].nickname
						item.mobilePhone = this.reserveUsersList[index].mobilePhone
						this.checkAllSelected()
						break
					case 'subscribeUsersList':
						this.subscribeUsersList[index].selected = true
						item.nickname = this.subscribeUsersList[index].Nickname
						item.mobilePhone = this.subscribeUsersList[index].MobilePhone
						this.checkAllSelected()
						break
					case 'allUsersList':
						this.allUsersList[index].selected = true
						item.nickname = this.allUsersList[index].Nickname
						item.mobilePhone = this.allUsersList[index].MobilePhone
						break
				}

				this.addedList.push(item)
			},
			/**
			 * 移除单个用户
			 *
			 * @param index    所选序号
			 */
			removeUser(index) {
				switch (this.activeName) {
					case 'reserveUsersList':
						this.reserveUsersList[index].selected = false
						this.addedList.splice(
							this.addedList.findIndex(
								i => i.mobilePhone === this.reserveUsersList[index].mobilePhone
							),
							1
						)
						this.checkAllSelected()
						break
					case 'subscribeUsersList':
						this.subscribeUsersList[index].selected = false
						this.addedList.splice(
							this.addedList.findIndex(
								i => i.mobilePhone === this.subscribeUsersList[index].MobilePhone
							),
							1
						)
						this.checkAllSelected()
						break
					case 'allUsersList':
						this.allUsersList[index].selected = false
						this.addedList.splice(
							this.addedList.findIndex(
								i => i.mobilePhone === this.allUsersList[index].MobilePhone
							),
							1
						)
						break
				}
			},
			/**
			 * 移除单个已选用户
			 *
			 * @param index    所选序号
			 */
			removeAddedUser(index) {
				this.addedList[index].selected = false
				this.addedList.splice(index, 1)
				switch (this.activeName) {
					case 'reserveUsersList':
						this.getLiveAppointUser()
						break
					case 'subscribeUsersList':
						this.getMyFollowingList()
						break
					case 'allUsersList':
						this.getUserList()
						break
				}
			},
			/**
			 * 清空所有已选用户
			 */
			removeAllAddedUser() {
				this.addedList = []
				switch (this.activeName) {
					case 'reserveUsersList':
						this.getLiveAppointUser()
						break
					case 'subscribeUsersList':
						this.getMyFollowingList()
						break
					case 'allUsersList':
						this.getUserList()
						break
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.el-card,
	.el-message {
		border-radius: 0;
	}

	.el-card.is-always-shadow,
	.el-card.is-hover-shadow:focus,
	.el-card.is-hover-shadow:hover {
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
		border: 1px solid #dcdfe6;
	}

	.topbar {
		display: flex;
		justify-content: space-between;
		padding-bottom: 15px;
		border-bottom: 1px solid #dcdfe6;
	}

	.list {
		display: flex;
		flex-direction: column;

		.item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding-top: 15px;

			.name,
			.phone {
				text-align: left;
				width: 30%;
			}
		}

		.item:last-child {
			padding-bottom: 15px;
		}
	}

	.addedList {
		width: 101%;
		padding-right: 1%;
		height: 529px;
		overflow-y: auto;

		&::-webkit-scrollbar {
			width: 5px;
			height: 5px;
		}

		&::-webkit-scrollbar-thumb {
			border-radius: 2px;
			background: #2a354e;
		}

		&::-webkit-scrollbar-track {
			border-radius: 2px;
			background: #ededed;
		}
	}

	.bottom {
		display: flex;
		justify-content: start;
		padding-top: 15px;
		border-top: 1px solid #cccccc;
	}
</style>



// WEBPACK FOOTER //
// src/views/notificationManagement.vue
